export const TMDB_AUTH = "f61ae00c768cb26e8adfac1a5bc66419";
// Settings
export const isPaginationEnabled = true;
export const enableTruncateDescription = false;
export const CATEGORIES = ["top-rated", "popular", "now-playing", "search"];
export const initialCategory = "now-playing";
// API Backend
export const MOVIES_LIBRARY_URL =
  "https://hosteddatabase.frenchfriesrgud.repl.co/movies/";
